export default __webpack_public_path__ + "fonts/github_icon.91e612d26ca4a0a41fbd5a4b9449b1d2.png";